import script from "./simCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./simCard.vue?vue&type=script&setup=true&lang=ts"

import "./simCard.vue?vue&type=style&index=0&id=01a00c75&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/liulv-sound/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01a00c75"]])

export default __exports__